import PageTitle from "../../../layout/PageTitle";
import React from "react";
import {Alert, Container} from "react-bootstrap";
import ListTable from "../../shared/ListTable";
import {useQuery} from "@apollo/client";
import {getClientMeasurementsQuery} from "./ClientQueries";
import ClientMeasurementsChart from "./ClientMeasurementsChart";
import {useParams} from "react-router-dom";
import Loader from "../../shared/Loader";

const ClientMeasurementsList = () => {
  const params = useParams()
  const { data, loading } = useQuery(getClientMeasurementsQuery, { variables: { id: params.id } })

  const header = <tr>
    <th>Data</th>
    <th>Greutate</th>
    <th>Talie</th>
    <th>Bust</th>
    <th>Sold</th>
    <th>Maini</th>
    <th>Picioare</th>
    <th>Note</th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.formattedDate}</td>
      <td>{item.weight}</td>
      <td>{item.waist}</td>
      <td>{item.bust}</td>
      <td>{item.hips}</td>
      <td>{item.arms}</td>
      <td>{item.legs}</td>
      <td>{item.details}</td>
    </tr>
  }

  if (loading) return <Loader />;

  return (
    <Container>
      <PageTitle title={`Masuratori - ${data.client.fullName}`} />
      {data.client.measurements.length > 0 &&
        <div className='w-100'>
          <ClientMeasurementsChart data={data.client.measurements} />
        </div>
      }
      <div className="row justify-content-md-center mt-5">
        <div className="page-container col">
          {data.client.measurements.length > 0
            ?
            <ListTable data={data.client.measurements} header={header} listItem={listItem}
                       searchFields={['formattedDate', 'weight']} />
            :
            <Alert variant='warning'>Lista este goala</Alert>
          }
        </div>
      </div>
    </Container>
  );
}

export default ClientMeasurementsList;
